import lightGallery from "lightgallery"

const initLightGalleries = () => {
  document.querySelectorAll("[data-lightgallery]").forEach((element) => {
    if (element.dataset.lightgalleryInitialized === "1") return

    element._lightgalleryInstance = lightGallery(element, { selector: "[data-lightgallery-item]" })
    element.dataset.lightgalleryInitialized = "1"
  })
}

const destroyLightGalleries = () => {
  document.querySelectorAll("[data-lightgallery]").forEach((element) => {
    if (element.dataset.lightgalleryInitialized !== "1") return

    element._lightgalleryInstance?.destroy()
    delete element._lightgalleryInstance
    delete element.dataset.lightgalleryInitialized
  })
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initLightGalleries)
} else {
  initLightGalleries()
}

document.addEventListener("turbo:before-cache", destroyLightGalleries)
document.addEventListener("turbo:load", initLightGalleries)
